<template>
  <b-overlay :show="isLoading" rounded="sm">
    <div>
      <!--   Tags   -->
      <b-card class="mb-2">
        <h1>Meta Tags</h1>
        <div class="my-2">
          <b-row>
            <b-col
                cols="12"
                class=""
            >
              <b-row class="w-100">
                <b-col cols="6">
                  <div class="form-label-group">
                    <b-form @submit.prevent>
                      <b-form-group label="meta tag name" label-for="name">
                        <b-form-input
                            id="name"
                            placeholder="og:locale"
                            v-model="defaultCreateData.name"
                        />
                      </b-form-group>
                    </b-form>
                  </div>
                </b-col>
                <b-col cols="6">
                  <div class="form-label-group">
                    <b-form @submit.prevent>
                      <b-form-group label="content" label-for="content">
                        <b-form-input
                            id="content"
                            placeholder="fa_IR"
                            v-model="defaultCreateData.content"
                        />
                      </b-form-group>
                    </b-form>
                  </div>
                </b-col>
                <b-col cols="2">
                  <b-button
                      @click="createMetaTag"
                      variant="success"
                  >
                    <span class="text-nowrap">Add meta tag</span>
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>

        <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="data.metas"
            responsive
            :fields="myTableColumns"
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="No items available"
        >
          <!-- Column: delete -->

          <template #cell(actions)="data">
            <div class="d-flex align-items-center" style="gap: 2rem">
              <div @click="deleteMetaTag(data.item)" class="cursor-pointer">
                <feather-icon size="20" icon="TrashIcon" class="text-danger" />
              </div>
            </div>
          </template>
        </b-table>
      </b-card>

      <!--   Links   -->
      <b-card class="mb-2">
        <h1>Meta Links</h1>
        <div class="my-2">
          <b-row>
            <b-col
                cols="12"
                class=""
            >
              <b-row class="w-100">
                <b-col cols="6">
                  <div class="form-label-group">
                    <b-form @submit.prevent>
                      <b-form-group label="meta link rel" label-for="rel">
                        <b-form-input
                            id="rel"
                            placeholder="prefetch"
                            v-model="defaultCreateDataLink.rel"
                        />
                      </b-form-group>
                    </b-form>
                  </div>
                </b-col>
                <b-col cols="6">
                  <div class="form-label-group">
                    <b-form @submit.prevent>
                      <b-form-group label="href" label-for="href">
                        <b-form-input
                            id="href"
                            placeholder="www.something.com"
                            v-model="defaultCreateDataLink.href"
                        />
                      </b-form-group>
                    </b-form>
                  </div>
                </b-col>
                <b-col cols="2">
                  <b-button
                      @click="createMetaLink"
                      variant="success"
                  >
                    <span class="text-nowrap">Add meta link</span>
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>

        <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="data.links"
            responsive
            :fields="myTableColumnsTwo"
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="No items available"
        >
          <!-- Column: delete -->

          <template #cell(actions)="data">
            <div class="d-flex align-items-center" style="gap: 2rem">
              <div @click="deleteMetaLink(data.item)" class="cursor-pointer">
                <feather-icon size="20" icon="TrashIcon" class="text-danger" />
              </div>
            </div>
          </template>
        </b-table>
      </b-card>
    </div>
  </b-overlay>
</template>

<script>
import {
  BContainer,
  BCard,
  BRow,
  BCol,
  BForm,
  BFormRow,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
  BModal,
} from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import AddEditDeleteButton from "@/views/components/utils/AddEditDeleteButton.vue";
import {GetAllLangs} from "@/libs/Api/Language";
import {TagAddTagToEntity, TagGetEntityTypeTagsByObjectId, TagRemoveTagFromEntity} from "@/libs/Api/TagRequest";

export default {
  name: "Meta",
  data() {
    return {
      isLoading: false,
      myTableColumns: [
        {
          key: "name",
          label: "Name",
        },
        {
          key: "content",
          label: "content",
        },
        {
          key: "actions",
          label: "Actions",
        },
      ],
      myTableColumnsTwo: [
        {
          key: "rel",
          label: "Rel",
        },
        {
          key: "href",
          label: "href",
        },
        {
          key: "actions",
          label: "Actions",
        },
      ],
      defaultCreateData: {
        name:null,
        content: null
      },
      defaultCreateDataLink: {
        rel:null,
        href: null
      },
    };
  },
  props:{
    data:{
      required: true,
    },
  },
  methods: {
    createMetaTag(){
      if (this.defaultCreateData.name && this.defaultCreateData.content){
        this.data.metas.push(this.defaultCreateData);
      }
    },
    createMetaLink(){
      if (this.defaultCreateDataLink.rel && this.defaultCreateDataLink.href){
        this.data.links.push(this.defaultCreateDataLink);
      }
    },
    deleteMetaTag(item){
      let arr = this.data.metas;
      let idx = arr.findIndex(e => e.name === item.name && e.content === item.content);
      arr.splice(idx,1);
    },
    deleteMetaLink(item){
      let arr = this.data.links;
      let idx = arr.findIndex(e => e.rel === item.rel && e.href === item.href);
      arr.splice(idx,1);
    },
  },
  components: {
    BContainer,
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BFormRow,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BModal,
    vSelect,
    AddEditDeleteButton,
  },
};
</script>

<style scoped></style>
